module.exports = __webpack_public_path__ + "static/HDSI-55cabb9228acd940f137897345ba780a.jpg";